import React from 'react'
import '../layout/PoliPri.Module.css'
import { Trans } from 'react-i18next';
import i18n from './i18n'
import { privacyPolicy} from '../cookiesPolicy'

function PoliPriva() {
  return (
    <div className='container PoliPriva'>
        <div className='text'>
            
        </div>

      {privacyPolicy.map((item, index) => (
      <div className="poli-priva" key={index}>
        <Trans i18nKey={`cookiesPolicy_${index}`} components={{
            1: <h1 />,
            2: <strong />,
            3: <br />,
            4: <p />,
            5: <ul/>,
            6: <li/>,
            7: <a/>, 
          }} >
          {item.text[i18n.language].replace(/&nbsp;/g, ' ')}
        </Trans>
      </div>
    ))}
      </div>
  )
}

export default PoliPriva